// extracted by mini-css-extract-plugin
module.exports = {"svgDefinitions":"Layout_svgDefinitions__h5q30","grid":"Layout_grid__qZRWT"};